<template>
    <v-dialog v-model="dialog" persistent max-width="290">
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="datetime"
          label="Due Date"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <v-card>
        <v-card-title class="headline">Pick a Date & Time</v-card-title>
        <v-card-text>
          <v-date-picker v-model="date" no-title scrollable />
          <v-divider class="my-2" />
          <v-time-picker v-model="time" format="24hr" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="save">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: 'DateTimePicker',
    data: () => ({
      dialog: false,
      date: null,
      time: null,
      datetime: '',
    }),
    methods: {
      save() {
        // Combine date and time (you might use a library like dayjs for better formatting)
        this.datetime = `${this.date} ${this.time}`;
        this.dialog = false;
        this.$emit('update:datetime', this.datetime);
      },
    },
  };
  </script>
  